import * as React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { ActionMenuIntegracaoStyle } from './styles'
import { KeyboardArrowDown } from '@mui/icons-material'
import { Button, Menu } from '@mui/material'
import { translate } from '../../../../../i18n/index'

const ActionMenuIntegracao = () => {
  const history = useHistory()

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
      setAnchorEl(null)
    }

  return <ActionMenuIntegracaoStyle>
    <Button
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClick}
      endIcon={<KeyboardArrowDown />}
    >
      Integrações
    </Button>
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button'
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
    >
      <Link onClick={handleClose} to={{ pathname: '/token', state: history.location.pathname }} className='customMenuHeaderLink'>
        <span>{translate('labelTokenOnfarm')}</span>
      </Link>
      <Link onClick={handleClose} to={{ pathname: '/integracao-parceiros', state: history.location.pathname }} className='customMenuHeaderLink'>
        <span>{translate('labelParceiros')}</span>
      </Link>
    </Menu>
  </ActionMenuIntegracaoStyle>
}

export default ActionMenuIntegracao
